/* Portada · vitrina de recién llegadas (fallo de Moon, 12 oct 2026): una carta a la vista; flechas, dedo y teclado.
   Sin autoplay. La pista es un scroll nativo con ajuste por carta; este script solo sincroniza el contador, apaga las
   flechas en los extremos, deja fuera del tabulador y del lector las cartas que no se ven (inert) y precarga la carta
   vecina para que no aparezca el campo rosa vacío. Con «reducir movimiento» el salto es seco. Sin dependencias. */
(function () {
  var vitrina = document.querySelector('[data-vitrina]');
  if (!vitrina) return;
  var pista = vitrina.querySelector('[data-vitrina-pista]');
  var piezas = pista ? Array.prototype.slice.call(pista.querySelectorAll('[data-vitrina-pieza]')) : [];
  if (piezas.length < 2) return;

  var estado = vitrina.querySelector('[data-vitrina-estado]');
  var anterior = vitrina.querySelector('[data-vitrina-anterior]');
  var siguiente = vitrina.querySelector('[data-vitrina-siguiente]');
  var plantilla = vitrina.getAttribute('data-t-de') || '[n] / [total]';
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  var actual = 0;

  vitrina.classList.add('is-js');

  function relleno() {
    return parseFloat(window.getComputedStyle(pista).paddingLeft) || 0;
  }

  function precarga(i) {
    var pieza = piezas[i];
    if (!pieza) return;
    var img = pieza.querySelector('img[loading="lazy"]');
    if (img) img.setAttribute('loading', 'eager');
  }

  function pinta(i) {
    actual = i;
    piezas.forEach(function (pieza, j) {
      var activa = j === i;
      pieza.classList.toggle('is-actual', activa);
      if (activa) pieza.removeAttribute('inert');
      else pieza.setAttribute('inert', '');
    });
    precarga(i - 1);
    precarga(i + 1);
    if (estado) {
      var hace = piezas[i].getAttribute('data-hace');
      estado.textContent = plantilla.replace('[n]', i + 1).replace('[total]', piezas.length) + (hace ? ' · ' + hace : '');
    }
    if (anterior) anterior.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
    if (siguiente) siguiente.setAttribute('aria-disabled', i === piezas.length - 1 ? 'true' : 'false');
  }

  function alinea(i, suave) {
    pista.scrollTo({ left: piezas[i].offsetLeft - relleno(), behavior: suave && !reducido.matches ? 'smooth' : 'auto' });
  }

  function vaA(i, conFoco) {
    i = Math.max(0, Math.min(piezas.length - 1, i));
    if (i === actual) return;
    alinea(i, true);
    pinta(i);
    if (conFoco) {
      var enlace = piezas[i].querySelector('a');
      if (enlace) enlace.focus({ preventScroll: true });
    }
  }

  function indicePorScroll() {
    var x = pista.scrollLeft + relleno();
    var mejor = 0;
    var distancia = Infinity;
    piezas.forEach(function (pieza, j) {
      var d = Math.abs(pieza.offsetLeft - x);
      if (d < distancia) {
        distancia = d;
        mejor = j;
      }
    });
    return mejor;
  }

  if (anterior) anterior.addEventListener('click', function () { vaA(actual - 1); });
  if (siguiente) siguiente.addEventListener('click', function () { vaA(actual + 1); });

  /* Dedo, rueda o flecha: cuando el scroll se asienta, el contador y las flechas se ponen al día con la carta que de
     verdad se ve (si es la misma, no pasa nada) */
  var espera;
  pista.addEventListener('scroll', function () {
    clearTimeout(espera);
    espera = setTimeout(function () {
      var i = indicePorScroll();
      if (i !== actual) pinta(i);
    }, 80);
  }, { passive: true });

  /* Flechas del teclado con el foco dentro de la pista: cambian de carta y llevan el foco a la nueva */
  pista.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      vaA(actual + 1, true);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      vaA(actual - 1, true);
    }
  });

  /* Al cambiar el ancho, la pista vuelve a dejar la carta actual alineada */
  var redimension;
  window.addEventListener('resize', function () {
    clearTimeout(redimension);
    redimension = setTimeout(function () { alinea(actual, false); }, 120);
  });

  /* Si el navegador restauró un desplazamiento (volver atrás), se parte de la carta que de verdad se ve */
  pinta(indicePorScroll());
})();
